module.exports = __webpack_public_path__ + "img/005.f576883b.png";